import React from 'react';
import { FileText, Download, ExternalLink, ShieldCheck } from 'lucide-react';
import { LICENCE_PDF_1, LICENCE_PDF_2 } from '../mock';

const LICENCES = [
  {
    title: 'Licence to Operate Private Employment Agency',
    subtitle: 'John Herbert Limited — PEA/819',
    issuer: 'Ministry of Employment and Labour Relations, Ghana',
    url: LICENCE_PDF_1,
  },
  {
    title: 'Licence to Operate Private Employment Agency',
    subtitle: 'John Herbert Limited — Supporting Documentation',
    issuer: 'Ministry of Employment and Labour Relations, Ghana',
    url: LICENCE_PDF_2,
  },
];

export default function Licences() {
  return (
    <section id="licences" className="jh-section bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 max-w-3xl mx-auto">
          <span className="jh-eyebrow">Our Licences & Accreditation</span>
          <h2 className="jh-h2 text-[#0e1421] mt-4">
            Fully Licensed & Government Authorised
          </h2>
          <p className="text-gray-600 mt-5 leading-relaxed">
            John Herbert Limited operates as a Private Employment Agency
            authorised under the Labour Act, 2003 (Act 651). View or download
            our official licence documents below.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {LICENCES.map((l, i) => (
            <div
              key={i}
              className="group border border-black/10 rounded-xl p-8 flex flex-col md:flex-row gap-6 items-start hover:border-[#E11D2E] hover:shadow-xl transition-all bg-white"
            >
              <div className="w-16 h-16 rounded-lg bg-[#E11D2E]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#E11D2E] transition-colors">
                <FileText
                  size={30}
                  className="text-[#E11D2E] group-hover:text-white transition-colors"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <ShieldCheck size={16} className="text-[#E11D2E]" />
                  <span className="text-[12px] font-semibold uppercase tracking-widest text-[#E11D2E]">
                    Official Document
                  </span>
                </div>
                <h3 className="font-display font-extrabold text-[20px] text-[#0e1421] leading-tight mb-1">
                  {l.title}
                </h3>
                <p className="text-[14px] text-gray-700 font-medium mb-1">
                  {l.subtitle}
                </p>
                <p className="text-[13px] text-gray-500 mb-5">{l.issuer}</p>

                <div className="flex flex-wrap gap-3">
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#0e1421] text-white text-[13px] font-medium hover:bg-[#1c2536] transition-colors"
                  >
                    <ExternalLink size={15} /> View Licence
                  </a>
                  <a
                    href={l.url}
                    download
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-black/15 text-[#0e1421] text-[13px] font-medium hover:border-[#E11D2E] hover:text-[#E11D2E] transition-colors"
                  >
                    <Download size={15} /> Download PDF
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
